var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgDatacheck(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.23547 0.735291C4.54429 0.735291 0.706055 4.57353 0.706055 9.2647C0.706055 13.9559 4.54429 17.7941 9.23547 17.7941C13.9266 17.7941 17.7649 13.9559 17.7649 9.2647C17.7649 4.57353 13.9266 0.735291 9.23547 0.735291ZM12.8178 7.8147L8.7237 11.9088C8.38252 12.25 7.87076 12.25 7.52958 11.9088L5.65311 10.0323C5.31194 9.69117 5.31194 9.17941 5.65311 8.83823C5.99429 8.49706 6.50605 8.49706 6.84723 8.83823L8.12664 10.1176L11.6237 6.62058C11.9649 6.27941 12.4766 6.27941 12.8178 6.62058C13.159 6.96176 13.159 7.47353 12.8178 7.8147Z",
    fill: "#985B5B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDatacheck);
export default __webpack_public_path__ + "static/media/datacheck.f19d8e7b74dc510809d649460ebdb3d4.svg";
export { ForwardRef as ReactComponent };